import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// SSR 必须用同步 import，动态 import() 会触发 webpack chunk loading 引用 document
import HomePage from '@/pages/HomePage.vue'
import NewsListPage from '@/pages/NewsListPage.vue'
import LatestGamesPage from '@/pages/LatestGamesPage.vue'
import ArticlePage from '@/pages/ArticlePage.vue'
import GameHubPage from '@/pages/GameHubPage.vue'
import PlatformPage from '@/pages/PlatformPage.vue'
import TagPage from '@/pages/TagPage.vue'
import LegalPage from '@/pages/LegalPage.vue'

// Subcategory 白名单（精确路由，优先于 :slug 动态路由）
const subcategoryMap = {
  news: ['latest-news', 'trending', 'release-dates', 'industry-news', 'rumors'],
  reviews: ['game-reviews', 'hardware-reviews', 'dlc-reviews', 'indie-reviews'],
  guides: ['walkthroughs', 'tips-tricks', 'builds', 'beginners-guides', 'advanced-guides'],
  deals: ['game-deals', 'hardware-deals', 'subscription-deals', 'bundle-deals'],
}

// 生成 subcategory 精确路由
function generateSubcategoryRoutes() {
  const routes = []
  for (const [category, subcategories] of Object.entries(subcategoryMap)) {
    for (const sub of subcategories) {
      routes.push({
        path: `/${category}/${sub}/`,
        name: `${category}-${sub}`,
        component: NewsListPage,
        meta: { category, subcategory: sub },
      })
    }
  }
  return routes
}

// 4 条文章动态路由（每个 category 一条）
const categorySlugs = ['news', 'reviews', 'guides', 'deals']


const legalRoutes = [
  {
    path: '/privacy-policy/',
    name: 'privacy-policy',
    component: LegalPage,
    meta: { legalKey: 'privacy-policy', title: 'Privacy Policy' },
  },
  {
    path: '/terms-of-service/',
    name: 'terms-of-service',
    component: LegalPage,
    meta: { legalKey: 'terms-of-service', title: 'Terms of Service' },
  },
  {
    path: '/cookie-policy/',
    name: 'cookie-policy',
    component: LegalPage,
    meta: { legalKey: 'cookie-policy', title: 'Cookie Policy' },
  },
  {
    path: '/disclaimer/',
    name: 'disclaimer',
    component: LegalPage,
    meta: { legalKey: 'disclaimer', title: 'Disclaimer' },
  },
  {
    path: '/about-us/',
    name: 'about-us',
    component: LegalPage,
    meta: { legalKey: 'about-us', title: 'About Us' },
  },
  {
    path: '/contact-us/',
    name: 'contact-us',
    component: LegalPage,
    meta: { legalKey: 'contact-us', title: 'Contact Us' },
  },
]


const categoryRoutes = [
  {
    path: '/games/',
    name: 'latest-games',
    component: LatestGamesPage,
    meta: { title: 'Latest Games' },
  },
  {
    path: '/latest-gaming-news/',
    redirect: '/games/',
  },
  {
    path: '/news/',
    name: 'news',
    component: NewsListPage,
    meta: { category: 'news', title: 'Latest Gaming News' },
  },
  {
    path: '/reviews/',
    name: 'reviews',
    component: NewsListPage,
    meta: { category: 'reviews', title: 'Game Reviews' },
  },
  {
    path: '/guides/',
    name: 'guides',
    component: NewsListPage,
    meta: { category: 'guides', title: 'Gaming Guides & Tips' },
  },
  {
    path: '/deals/',
    name: 'deals',
    component: NewsListPage,
    meta: { category: 'deals', title: 'Gaming Deals & Offers' },
  },
]

const articleRoutes = categorySlugs.map(category => ({
  path: `/${category}/:slug/`,
  name: `${category}-article`,
  component: ArticlePage,
  meta: { category },
}))

const appRoutes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: { title: 'Gaming News, Reviews & Guides' },
  },
  ...categoryRoutes,
  {
    path: '/tags/',
    name: 'tags',
    component: TagPage,
    meta: { title: 'All Tags' },
  },
  ...generateSubcategoryRoutes(),
  ...articleRoutes,
  {
    path: '/platforms/:slug/',
    name: 'platform',
    component: PlatformPage,
  },
  {
    path: '/games/:slug/',
    name: 'game-hub',
    component: GameHubPage,
  },
  {
    path: '/tags/:tag/',
    name: 'tag',
    component: TagPage,
  },
  ...legalRoutes,
  {
    path: '*',
    name: '404',
    component: HomePage,
    meta: { title: 'Page Not Found' },
  },
]

export default function createRouter() {
  const router = new VueRouter({
    mode: 'history',
    routes: appRoutes,
  })

  // Trailing slash enforcement
  router.beforeEach((to, from, next) => {
    if (to.path !== '/' && !to.path.endsWith('/')) {
      next({ path: to.path + '/', query: to.query, hash: to.hash })
    } else {
      next()
    }
  })

  return router
}
